// 手机端 el-carousel 按内容撑开高度，避免图文叠排后文字被裁切或上下留白过大
export default {
  data() {
    return {
      isMobile: typeof window !== 'undefined' && window.innerWidth < 768,
      mobileSlideHeight: 400
    }
  },
  computed: {
    slideHeight() {
      return this.isMobile ? this.mobileSlideHeight : this.bannerHeight
    }
  },
  mounted() {
    this.syncMobileCarouselLayout()
    window.addEventListener('resize', this.syncMobileCarouselLayout)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.syncMobileCarouselLayout)
  },
  methods: {
    syncMobileCarouselLayout() {
      this.isMobile = window.innerWidth < 768
      if (!this.isMobile) return
      this.$nextTick(() => {
        this.measureMobileSlideHeight()
        setTimeout(this.measureMobileSlideHeight, 400)
      })
    },
    measureMobileSlideHeight() {
      if (!this.$el) return
      const boxes = this.$el.querySelectorAll('.carousel-box')
      let max = 0
      Array.prototype.forEach.call(boxes, (el) => {
        const prevMinHeight = el.style.minHeight
        const prevHeight = el.style.height
        el.style.minHeight = '0'
        el.style.height = 'auto'
        max = Math.max(max, el.scrollHeight)
        el.style.minHeight = prevMinHeight
        el.style.height = prevHeight
      })
      if (max > 0 && Math.abs(max - this.mobileSlideHeight) > 2) {
        this.mobileSlideHeight = max
      }
    }
  }
}
